;(() => {
  const LOG_PREFIX = '[U1 Bundle Controller]'
  const LS_KEY = 'u1_pdp_discount_code'

  const q = (sel, root = document) => root.querySelector(sel)
  const qa = (sel, root = document) => Array.from(root.querySelectorAll(sel))
  const safeJsonParse = (el, fallback) => {
    try {
      const raw = (el && el.textContent ? el.textContent : '')
      const s = String(raw || '').trim()
      return JSON.parse(s || fallback)
    } catch (_e) {
      try { return JSON.parse(fallback) } catch (_e2) { return null }
    }
  }
  const normalizeHandle = (s) =>
    String(s || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')

  const cleanTextVal = (s) => {
    const raw = String(s || '').trim()
    const h = normalizeHandle(raw)
    if (!raw) return ''
    if (h === '-' || h === 'none' || h === 'null') return ''
    return raw
  }

  const splitCsv = (csv) => {
    const s = String(csv || '').trim()
    if (!s) return []
    return s
      .split(',')
      .map((x) => normalizeHandle(x))
      .filter(Boolean)
      .filter((t) => t !== '-' && t !== 'none' && t !== '—')
  }

  const inAllowedCountry = (country, allowedCsv) => {
    const allowedRaw = String(allowedCsv || '').trim()
    if (!allowedRaw || normalizeHandle(allowedRaw) === 'all') return true
    const allowed = splitCsv(allowedRaw).map((x) => String(x || '').toUpperCase())
    if (!allowed.length) return true
    const c = String(country || '').toUpperCase()
    return !!(c && allowed.includes(c))
  }

  const getPdpRoot = () => q('.u1-pdp-customizer')

  const getMainProductHandle = () => {
    try {
      const sel = window.__u1PdpSelection || null
      const h = sel && typeof sel.productHandle === 'string' ? sel.productHandle : ''
      return normalizeHandle(h)
    } catch (_e) { return '' }
  }

  const getSelectedMainVariantId = () => {
    try {
      const sel = window.__u1PdpSelection || null
      const v = sel && sel.variantId != null ? Number(sel.variantId) : 0
      return Number.isFinite(v) && v > 0 ? v : 0
    } catch (_e) {
      return 0
    }
  }

  const parseVariantIdCsv = (csv) =>
    String(csv || '')
      .split(',')
      .map((x) => {
        const raw = String(x || '')
          .trim()
          .replace(/[^\d]/g, '')
        const n = parseInt(raw, 10)
        return Number.isFinite(n) && n > 0 ? n : 0
      })
      .filter(Boolean)

  const variantIdsRuleMatches = (requiredCsv, variantId) => {
    const ids = parseVariantIdCsv(requiredCsv || '')
    if (!ids.length) return true
    const v = Number(variantId || 0) || 0
    return !!(v && ids.includes(v))
  }

  const getVariantIdFromModelBtn = (btn) => {
    if (!btn || !btn.dataset) return 0
    const v = Number(btn.dataset.u1PdpModelVariantId || 0) || 0
    return Number.isFinite(v) && v > 0 ? v : 0
  }

  const getSelectedAccessoryHandles = (pdpRoot) => {
    const root = pdpRoot || getPdpRoot()
    if (!root) return []
    const btns = qa('[data-u1-pdp-accessory]', root)
    const selected = btns.filter((b) => {
      try {
        if (b.getAttribute('aria-pressed') === 'true') return true
        if (b.classList && b.classList.contains('is-selected')) return true
      } catch (_e) {}
      return false
    })
    return selected
      .map((b) => normalizeHandle(b && b.dataset ? b.dataset.u1PdpAccessoryHandle || '' : ''))
      .filter(Boolean)
  }

  const setPersistedCode = (code) => {
    const c = String(code || '').trim()
    try {
      if (!c) localStorage.removeItem(LS_KEY)
      else localStorage.setItem(LS_KEY, c)
    } catch (_e) {}
  }

  const getPersistedCode = () => {
    try { return String(localStorage.getItem(LS_KEY) || '').trim() } catch (_e) { return '' }
  }

  const applyDiscountCookie = (code, { debug } = { debug: false }) => {
    const c = String(code || '').trim()
    if (!c) return Promise.resolve(false)
    const url = `/discount/${encodeURIComponent(c)}?redirect=/cart`
    return new Promise((resolve) => {
      try {
        const id = 'u1-bundle-controller-discount-frame'
        let f = document.getElementById(id)
        if (!f) {
          f = document.createElement('iframe')
          f.id = id
          f.tabIndex = -1
          f.setAttribute('aria-hidden', 'true')
          f.style.cssText =
            'position:absolute;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none;'
          document.body.appendChild(f)
        }
        let done = false
        const finish = (ok) => {
          if (done) return
          done = true
          resolve(!!ok)
        }
        try {
          f.onload = () => finish(true)
          f.onerror = () => finish(false)
        } catch (_e0) {}
        if (debug) console.log(LOG_PREFIX, 'Applying discount via iframe:', url)
        f.src = url
        setTimeout(() => finish(false), 1800)
      } catch (_e) {
        resolve(false)
      }
    })
  }

  const pickBestTier = ({ tiers, mainHandle, selectedAccSet }) => {
    const list = Array.isArray(tiers) ? tiers : []
    const closedRules = getClosedBundleRules()
    const pickOneIds = new Set(closedRules.filter((r) => r && r.pickOne === true).map((r) => String(r.id)))
    const matches = []
    list.forEach((t, idx) => {
      if (!t || typeof t !== 'object') return
      const code = cleanTextVal(t.discountCode || '')
      if (!code) return
      const req = splitCsv(t.requiredAccessoryHandlesCsv || '')
      const appliesTo = normalizeHandle(t.appliesToMainProductHandle || '')
      if (appliesTo && mainHandle && appliesTo !== mainHandle) return
      if (!variantIdsRuleMatches(t.requiredMainVariantIdsCsv || '', getSelectedMainVariantId())) return
      const isPickOne = pickOneIds.has(String(t.id))
      const ok = isPickOne
        ? req.some((h) => selectedAccSet.has(normalizeHandle(h)))
        : req.every((h) => selectedAccSet.has(normalizeHandle(h)))
      if (!ok) return
      const priority = Number(t.priority || 0) || 0
      matches.push({
        idx,
        code,
        reqCount: req.length,
        priority,
        label: String(t.label || '').trim(),
      })
    })
    matches.sort((a, b) => {
      if (b.priority !== a.priority) return b.priority - a.priority
      if (b.reqCount !== a.reqCount) return b.reqCount - a.reqCount
      return a.idx - b.idx
    })
    return matches[0] || null
  }

  const computeFinalCode = ({ cfg, tiers, pdpRoot }) => {
    const enabled = !!cfg && cfg.enabled === true
    const applyOnChange = !!cfg && cfg.applyOnChange === true
    const debug = !!cfg && cfg.debug === true
    const allowed = inAllowedCountry(cfg.country || '', cfg.allowedCountriesCsv || '')
    if (!enabled || !allowed) return { code: '', applyOnChange, debug, reason: !enabled ? 'disabled' : 'country_blocked' }

    const mainHandle = getMainProductHandle()
    const selectedAcc = getSelectedAccessoryHandles(pdpRoot)
    const selectedSet = new Set(selectedAcc)

    const tier = pickBestTier({ tiers, mainHandle, selectedAccSet: selectedSet })
    if (tier && tier.code) return { code: tier.code, applyOnChange, debug, reason: 'tier', tier, mainHandle, selectedAcc }

    // Base rule: only when NO accessories selected
    const baseCode = cleanTextVal(cfg.baseCode || '')
    const baseAppliesTo = normalizeHandle(cfg.baseAppliesToMainProductHandle || '')
    if (baseCode && selectedAcc.length === 0) {
      if (!baseAppliesTo || (mainHandle && baseAppliesTo === mainHandle)) {
        return { code: baseCode, applyOnChange, debug, reason: 'base', mainHandle, selectedAcc }
      }
    }

    return { code: '', applyOnChange, debug, reason: 'no_match', mainHandle, selectedAcc }
  }

  const refreshCartSections = () => {
    try { document.documentElement.dispatchEvent(new Event('cart:refresh')) } catch (_e) {}
  }

  const attach = () => {
    const host = q('[data-u1-pdp-bundle-controller]')
    if (!host) return false
    if (host._u1Bound) return true
    host._u1Bound = true

    const cfgEl = q('[data-u1-pdp-bundle-controller-config]', host)
    const tiersEl = q('[data-u1-pdp-bundle-controller-tiers]', host)
    const cfg = safeJsonParse(cfgEl, '{}') || {}
    const tiers = safeJsonParse(tiersEl, '[]') || []

    const pdpRoot = getPdpRoot()

    const run = () => {
      const prev = getPersistedCode()
      const out = computeFinalCode({ cfg, tiers, pdpRoot })
      const next = String(out.code || '').trim()

      if (out.debug) {
        console.log(LOG_PREFIX, 'State:', {
          reason: out.reason,
          mainHandle: out.mainHandle,
          selectedAcc: out.selectedAcc,
          next,
          prev,
          tier: out.tier || null,
          country: cfg.country,
          allowedCountriesCsv: cfg.allowedCountriesCsv,
        })
      }

      if (next === prev) return
      setPersistedCode(next)

      if (!cfg || cfg.applyOnChange !== true) return
      if (!next) return
      applyDiscountCookie(next, { debug: out.debug }).finally(() => {
        setTimeout(refreshCartSections, 120)
        setTimeout(refreshCartSections, 650)
      })
    }

    // Initial
    run()

    // Rerun on PDP selection updates
    try {
      window.addEventListener('u1:pdp:selection', () => {
        setTimeout(run, 0)
      })
    } catch (_e) {}

    // Rerun on accessory clicks
    if (pdpRoot) {
      try {
        pdpRoot.addEventListener(
          'click',
          (e) => {
            const t = e && e.target && e.target.closest ? e.target : null
            if (!t) return
            if (t.closest('[data-u1-pdp-accessory]')) setTimeout(run, 0)
            if (t.closest('[data-u1-pdp-product-model], [data-u1-pdp-model]')) setTimeout(run, 0)
          },
          { passive: true }
        )
      } catch (_e) {}
    }

    return true
  }

  const init = () => {
    let tries = 0
    const tick = () => {
      tries += 1
      if (attach()) return
      if (tries > 120) return
      try { requestAnimationFrame(tick) } catch (_e) {}
    }
    tick()
  }

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true })
    else init()
  } catch (_e) {}
})()

// Closed Bundle UI: auto-select & lock required accessories.
// Reads from [data-u1-pdp-closed-bundles] in pdp-customizer-bundle section.
// Completely separate from the open-discount bundle_discount blocks in pdp-customizer.liquid.
;(() => {
  // ── Helpers ──────────────────────────────────────────────────────────────────

  const handleMatch = (a, b) => {
    const ha = String(a || '').trim().toLowerCase()
    const hb = String(b || '').trim().toLowerCase()
    return !!ha && !!hb && (ha === hb || ha.includes(hb) || hb.includes(ha))
  }

  const parseMoneyCents = (s) => {
    let raw = String(s || '')
    // Detect comma-as-decimal: "€39,90" or "1.234,56" (EU format)
    const hasComma = raw.includes(',')
    const hasDot   = raw.includes('.')
    if (hasComma && !hasDot) {
      // Comma is the decimal separator (e.g. €39,90)
      raw = raw.replace(',', '.')
    } else if (hasComma && hasDot) {
      // Both present: last one is decimal (e.g. 1.234,56 → 1234.56 or 1,234.56 → 1234.56)
      const lastComma = raw.lastIndexOf(',')
      const lastDot   = raw.lastIndexOf('.')
      if (lastComma > lastDot) {
        raw = raw.replace(/\./g, '').replace(',', '.')
      } else {
        raw = raw.replace(/,/g, '')
      }
    }
    const n = parseFloat(raw.replace(/[^0-9.]/g, '')) || 0
    return Math.round(n * 100)
  }

  const moneyFormat = (sample) => {
    const m = String(sample || '').match(/^([^\d]*)[\d,.]+([^\d]*)$/)
    return { pre: m ? m[1] : '$', suf: m ? m[2] : '' }
  }

  const _sampleUsesCommaDecimal = (sample) => {
    const s = String(sample || '')
    // e.g. "€159,90" or "€ 1.234,56" → comma is decimal
    const lastComma = s.lastIndexOf(',')
    const lastDot   = s.lastIndexOf('.')
    if (lastComma < 0) return false
    if (lastDot < 0) return true          // comma present, no dot → comma is decimal
    return lastComma > lastDot            // comma after dot → comma is decimal
  }

  const formatCentsLike = (cents, sample) => {
    const { pre, suf } = moneyFormat(sample)
    const amount = (cents / 100).toFixed(2)
    const formatted = _sampleUsesCommaDecimal(sample) ? amount.replace('.', ',') : amount
    return pre + formatted + suf
  }

  // Extract numeric % from a label like "27% OFF" → 27
  const extractPct = (label) => {
    const m = String(label || '').match(/(\d+(?:\.\d+)?)/)
    return m ? parseFloat(m[1]) : 0
  }

  const getSelMainVariantId = () => {
    try {
      const sel = window.__u1PdpSelection || null
      const v = sel && sel.variantId != null ? Number(sel.variantId) : 0
      return Number.isFinite(v) && v > 0 ? v : 0
    } catch (_) {
      return 0
    }
  }

  const parseVariantIds = (csv) =>
    String(csv || '')
      .split(',')
      .map((x) => {
        const raw = String(x || '').trim().replace(/[^\d]/g, '')
        const n = parseInt(raw, 10)
        return Number.isFinite(n) && n > 0 ? n : 0
      })
      .filter(Boolean)

  const nh = (s) =>
    String(s || '')
      .trim()
      .toLowerCase()
      .replace(/[\s_]+/g, '-')

  const splitModelHandlesCsv = (csv) =>
    String(csv || '')
      .split(',')
      .map((x) => nh(x))
      .filter(Boolean)
      .filter((t) => t !== '-' && t !== 'none')

  const ruleVariantOk = (csv, variantId) => {
    const ids = parseVariantIds(csv || '')
    if (!ids.length) return true
    const v = Number(variantId || 0) || 0
    // Sin ID aún (p. ej. recién clic en modelo): no bloquear; al resolver se revalida syncForRoot.
    if (!v) return true
    return ids.includes(v)
  }

  const variantIdFromModelBtn = (btn) => {
    if (!btn || !btn.dataset) return 0
    const v = Number(btn.dataset.u1PdpModelVariantId || 0) || 0
    return Number.isFinite(v) && v > 0 ? v : 0
  }

  /** Regalo sin % en etiqueta */
  const labelImpliesFreeAccessory = (label) => {
    if (extractPct(label) > 0) return false
    return /(?:^|\b)(free|gratis|regalo|gift|included)(\b|$)/i.test(String(label || '').trim()) || /100\s*%|100%/i.test(String(label || ''))
  }

  // ── Closed bundle rules ───────────────────────────────────────────────────────

  /** `click()` desde este script: el listener del PDP no debe bloquear por color/talla/aria-disabled. */
  const clickAccessoryWithClosedBundleBypass = (el) => {
    if (!el) return
    try {
      el.dataset.u1ClosedBundleAuto = '1'
    } catch (_) {}
    el.click()
  }

  const getClosedBundleRules = () => {
    try {
      const el = document.querySelector('[data-u1-pdp-closed-bundles]')
      return el ? JSON.parse(el.textContent || '[]') : []
    } catch (_) { return [] }
  }

  const findActiveRule = (modelBtn, root) => {
    if (!modelBtn) return null
    const rules = getClosedBundleRules()
    if (!rules.length) return null
    const modelHandleNorm = nh(modelBtn.dataset.u1PdpProductModelHandle || '')
    const modelPid = Number(modelBtn.dataset.u1PdpProductModelId || 0) || 0
    const btnVid = variantIdFromModelBtn(modelBtn)
    const sel = !!(modelBtn.classList && modelBtn.classList.contains('is-selected'))
    const vid = sel ? getSelMainVariantId() || btnVid : btnVid
    const pageMainNorm = nh(
      (root && root.dataset && root.dataset.u1PdpMainProductHandle) || ''
    )
    /** Casco PDP “variant model”: botón sin product id — el handle es el valor de opción (ej. Neon SE). */
    const variantModelRow = !modelPid

    return (
      rules.find((r) => {
        if (!r) return false
        if (!r.accessoryHandlesCsv || !String(r.accessoryHandlesCsv).trim()) return false

        const rHandle = String(r.mainProductHandle || '').trim().toLowerCase()
        const rId = Number(r.mainProductId || 0) || 0

        if (rHandle) {
          if (variantModelRow) {
            if (!pageMainNorm || rHandle !== pageMainNorm) return false
            const reqRows = splitModelHandlesCsv(r.requiredModelHandlesCsv || '')
            if (reqRows.length) {
              if (!modelHandleNorm || !reqRows.includes(modelHandleNorm)) return false
            }
          } else if (!modelHandleNorm || rHandle !== modelHandleNorm) {
            return false
          }
        } else if (rId && modelPid) {
          if (rId !== modelPid) return false
        } else if (rId && !modelPid) {
          return false
        }

        return ruleVariantOk(r.requiredMainVariantIdsCsv || '', vid)
      }) || null
    )
  }

  const restoreAccessoryCardFromBundleUi = (b) => {
    if (!b) return
    const wasInState = b.dataset.u1BundleAuto === 'true'
    delete b.dataset.u1BundleLocked
    delete b.dataset.u1BundleAuto
    delete b.dataset.u1BundlePickOneGroup
    const _uPromoEl = b.querySelector('[data-u1-pdp-card-promo]')
    const _uPromoOff = _uPromoEl && _uPromoEl.querySelector('[data-u1-pdp-card-promo-off]')
    if (_uPromoEl && _uPromoOff && b.dataset.u1BundlePromoOrig !== undefined) {
      _uPromoOff.textContent = b.dataset.u1BundlePromoOrig
      _uPromoEl.setAttribute('hidden', '')
      _uPromoEl.setAttribute('aria-hidden', 'true')
      delete b.dataset.u1BundlePromoOrig
    }
    const _uPriceRow = b.querySelector('[data-u1-pdp-card-price-row]')
    if (_uPriceRow && b.dataset.u1BundlePriceDisplay !== undefined) {
      _uPriceRow.style.display = b.dataset.u1BundlePriceDisplay
      delete b.dataset.u1BundlePriceDisplay
    }
    if (wasInState && b.classList.contains('is-selected')) {
      clickAccessoryWithClosedBundleBypass(b)
    } else {
      b.classList.remove('is-selected')
      b.setAttribute('aria-pressed', 'false')
    }
  }

  // ── Model card promo badge ────────────────────────────────────────────────────

  const roundLabelPct = (label) =>
    String(label || '').replace(/(\d+(?:\.\d+)?)%/, (_, n) => Math.ceil(parseFloat(n)) + '%')

  const showModelCardPromo = (btn, label) => {
    const promoEl   = btn.querySelector('[data-u1-pdp-card-promo]')
    const promoOff  = promoEl && promoEl.querySelector('[data-u1-pdp-card-promo-off]')
    const promoNote = promoEl && promoEl.querySelector('[data-u1-pdp-card-promo-note]')
    if (!promoEl || !promoOff) return
    const rounded = roundLabelPct(label)
    if (promoOff.textContent !== rounded) promoOff.textContent = rounded
    if (promoNote && !promoNote.textContent) promoNote.textContent = 'Limited time offer'
    promoEl.removeAttribute('hidden')
    promoEl.setAttribute('aria-hidden', 'false')
    btn.dataset.u1BundlePromoShown = 'true'
  }

  const hideModelCardPromo = (btn) => {
    if (!btn) return
    const promoEl   = btn.querySelector('[data-u1-pdp-card-promo]')
    const promoOff  = promoEl && promoEl.querySelector('[data-u1-pdp-card-promo-off]')
    const promoNote = promoEl && promoEl.querySelector('[data-u1-pdp-card-promo-note]')
    if (promoEl) { promoEl.setAttribute('hidden', ''); promoEl.setAttribute('aria-hidden', 'true') }
    if (promoOff) promoOff.textContent = ''
    if (promoNote) promoNote.textContent = ''
    try { delete btn.dataset.u1BundlePromoShown } catch (_) {}
  }

  // ── CTA total override ────────────────────────────────────────────────────────

  const applyBundleTotal = (root) => {
    const finalCents = Number(root._u1BundleFinalCents || 0) || 0
    if (!finalCents) return
    const msrpCents = Number(root._u1BundleMsrpCents || 0) || 0
    const extraCents = Number(root._u1BundleExtraAccCents || 0) || 0

    const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
    const msrpEl  = root.querySelector('[data-u1-pdp-atc-total-msrp]')
    const wrapEl  = root.querySelector('[data-u1-pdp-atc-total-wrap]')
    if (!totalEl) return

    const correctFinal = finalCents + extraCents
    const correctMsrp  = msrpCents  + extraCents
    const sample = totalEl.textContent || ''

    const newFinalText = sample ? formatCentsLike(correctFinal, sample) : ''
    const newMsrpText  = (msrpCents && sample) ? formatCentsLike(correctMsrp, sample) : ''

    if (newFinalText && totalEl.textContent !== newFinalText) totalEl.textContent = newFinalText
    if (msrpEl && newMsrpText && msrpEl.textContent !== newMsrpText) {
      msrpEl.textContent = newMsrpText
      msrpEl.setAttribute('aria-hidden', 'false')
    }
    if (wrapEl && !wrapEl.classList.contains('is-discount-on')) wrapEl.classList.add('is-discount-on')
    // Show "Save $XX" below total
    const saveEl = root.querySelector('[data-u1-pdp-atc-save]')
    const saveDiff = correctMsrp - correctFinal
    if (saveEl && saveDiff > 0 && sample) {
      const saveText = 'Save ' + formatCentsLike(saveDiff, sample)
      if (saveEl.textContent !== saveText) saveEl.textContent = saveText
      saveEl.removeAttribute('hidden')
      saveEl.setAttribute('aria-hidden', 'false')
    }
  }

  // ── Main sync ─────────────────────────────────────────────────────────────────

  const syncForRoot = (root) => {
    if (!root) return

    const allModelBtns = Array.from(
      root.querySelectorAll(
        '[data-u1-pdp-product-model], [data-u1-pdp-model]'
      )
    )
    const activeBtn    = allModelBtns.find(b => b.classList.contains('is-selected')) || null
    const modelOfferStaticOff = (btn) =>
      btn && btn.dataset ? String(btn.dataset.u1PdpModelOfferOff || '').trim() : ''
    const allAcc       = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'))
    allAcc.forEach((b) => {
      try { delete b.dataset.u1BundlePickOneGroup } catch (_e) {}
    })
    const ar           = findActiveRule(activeBtn, root)

    // Required handles for the CURRENT active closed bundle rule
    const activeHandles = ar
      ? String(ar.accessoryHandlesCsv || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
      : []
    if (ar && ar.pickOne && activeHandles.length >= 1) {
      const gid = 'u1p1-' + String(ar.id != null ? ar.id : '0').replace(/\W/g, '')
      activeHandles.forEach((rh) => {
        const b = allAcc.find((acc) => handleMatch(acc.dataset.u1PdpAccessoryHandle || '', rh))
        if (b) b.dataset.u1BundlePickOneGroup = gid
      })
    }
    const accInActiveRule = (b) => {
      const h = (b.dataset.u1PdpAccessoryHandle || '').toLowerCase()
      return activeHandles.some(rh => handleMatch(h, rh))
    }

    // Unlock accessories that are no longer required (model changed)
    allAcc.forEach((b) => {
      if (b.dataset.u1BundleLocked !== 'true') return
      if (accInActiveRule(b)) return
      restoreAccessoryCardFromBundleUi(b)
    })

    // Revert/update card overrides on non-active model buttons
    allModelBtns.forEach(b => {
      if (b === activeBtn) return
      const bRule = findActiveRule(b, root)

      // Title: keep bundle title if this button has a rule; otherwise revert if overridden
      if (bRule && bRule.bundleCardTitle) {
        const e = b.querySelector('[data-u1-pdp-card-title]')
        if (e) {
          if (b.dataset.u1BundleOT === undefined) b.dataset.u1BundleOT = e.textContent
          if (e.textContent !== bRule.bundleCardTitle) e.textContent = bRule.bundleCardTitle
        }
      } else if (b.dataset.u1BundleOT !== undefined) {
        const e = b.querySelector('[data-u1-pdp-card-title]')
        if (e) e.textContent = b.dataset.u1BundleOT
        delete b.dataset.u1BundleOT
      }

      // Promo en modelo: clásico = discountLabel; línea del theme editor = data-u1-pdp-model-offer-off (no pisarla)
      if (bRule && bRule.discountLabel && !bRule.pickOne) {
        showModelCardPromo(b, bRule.discountLabel)
      } else if (!modelOfferStaticOff(b)) {
        hideModelCardPromo(b)
      }

      // Price: use cached if available, otherwise calculate proactively for bundle cards
      if (b.dataset.u1BundleCachedMsrp && !bRule?.pickOne) {
        const r = b.querySelector('[data-u1-pdp-card-price-row]')
        if (r) {
          const cM = b.dataset.u1BundleCachedMsrp, cF = b.dataset.u1BundleCachedFinal
          const next = `<span class="u1-pdp-card__price u1-pdp-card__price--discount" data-u1-pdp-card-price><span class="u1-pdp-card__price-msrp">${cM}</span><span class="u1-pdp-card__price-final">${cF}</span></span>`
          if (r.innerHTML !== next) r.innerHTML = next
        }
        delete b.dataset.u1BundleOP
      } else if (bRule && !bRule.pickOne) {
        // Proactively calculate: read model price from the card + accessory prices from DOM
        const bCardPriceEl = b.querySelector('[data-u1-pdp-card-price]')
        const bModelPriceCents = parseMoneyCents(bCardPriceEl ? bCardPriceEl.textContent : '')
        const bHandles = String(bRule.accessoryHandlesCsv || '')
          .split(',').map((s) => s.trim().toLowerCase()).filter((s) => s && s !== '-')
        const bAccBtns = bHandles.map(
          (rh) => allAcc.find((acc) => handleMatch(acc.dataset.u1PdpAccessoryHandle || '', rh)) || null
        )
        let bAccPriceCents = bAccBtns.reduce(
          (sum, accBtn) => sum + (accBtn ? parseMoneyCents(accBtn.dataset.u1PdpInfoPrice || '') : 0),
          0
        )
        const bPct = extractPct(bRule.discountLabel || '')
        const bFree = bPct <= 0 && labelImpliesFreeAccessory(bRule.discountLabel || '')
        const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
        const sample = (totalEl && totalEl.textContent) || ''
        if (bModelPriceCents > 0 && bAccPriceCents > 0 && bPct > 0) {
          const bMsrpCents = bModelPriceCents + bAccPriceCents
          let bFinalCents = Math.round(bMsrpCents * (100 - bPct) / 100)
          if (bFinalCents % 100 === 50) bFinalCents += 50
          if (sample) {
            const bMsrpStr = formatCentsLike(bMsrpCents, sample)
            const bFinalStr = formatCentsLike(bFinalCents, sample)
            const r = b.querySelector('[data-u1-pdp-card-price-row]')
            if (r && bMsrpStr && bFinalStr) {
              const next = `<span class="u1-pdp-card__price u1-pdp-card__price--discount" data-u1-pdp-card-price><span class="u1-pdp-card__price-msrp">${bMsrpStr}</span><span class="u1-pdp-card__price-final">${bFinalStr}</span></span>`
              if (b.dataset.u1BundleOP === undefined) b.dataset.u1BundleOP = r.innerHTML
              b.dataset.u1BundleCachedMsrp = bMsrpStr
              b.dataset.u1BundleCachedFinal = bFinalStr
              if (r.innerHTML !== next) r.innerHTML = next
            }
          }
        } else if (bFree) {
          // “Free / Included” (sin %): no simular MSRP = casco+regalo.
          // El casco debe mantener su precio real en la card.
          if (b.dataset.u1BundleOP !== undefined) {
            const r = b.querySelector('[data-u1-pdp-card-price-row]')
            if (r) r.innerHTML = b.dataset.u1BundleOP
            delete b.dataset.u1BundleOP
          }
          delete b.dataset.u1BundleCachedMsrp
          delete b.dataset.u1BundleCachedFinal
        }
      } else if (bRule && bRule.pickOne && b.dataset.u1BundleOP !== undefined) {
        const r = b.querySelector('[data-u1-pdp-card-price-row]')
        if (r) r.innerHTML = b.dataset.u1BundleOP
        delete b.dataset.u1BundleOP
        delete b.dataset.u1BundleCachedMsrp
        delete b.dataset.u1BundleCachedFinal
      } else if (b.dataset.u1BundleOP !== undefined) {
        const r = b.querySelector('[data-u1-pdp-card-price-row]')
        if (r) r.innerHTML = b.dataset.u1BundleOP
        delete b.dataset.u1BundleOP
      }
    })

    // Clear price state when no active rule
    if (!ar || !activeBtn) {
      root._u1BundleFinalCents = 0
      root._u1BundleMsrpCents = 0
      root._u1BundleExtraAccCents = 0
      const _saveEl = root.querySelector('[data-u1-pdp-atc-save]')
      if (_saveEl) {
        _saveEl.setAttribute('hidden', '')
        _saveEl.setAttribute('aria-hidden', 'true')
      }
      const _wrapEl = root.querySelector('[data-u1-pdp-atc-total-wrap]')
      if (_wrapEl) _wrapEl.classList.remove('is-discount-on')

      // Hide "Bundle & Save" banner when no bundle rule is active
      const _bannerEl = root.querySelector('[data-u1-pdp-bundle-save]')
      if (_bannerEl) { _bannerEl.setAttribute('hidden', ''); _bannerEl.setAttribute('aria-hidden', 'true') }

      // Build set of accessory handles that belong to ANY closed bundle rule
      const _allRules = getClosedBundleRules()
      const _bundleAccSet = new Set()
      _allRules.forEach((r) => {
        String(r.accessoryHandlesCsv || '').split(',').forEach((h) => {
          const n = h.trim().toLowerCase()
          if (n && n !== '-') _bundleAccSet.add(n)
        })
      })

      allAcc.forEach((b) => {
        delete b.dataset.u1BundleLocked
        delete b.dataset.u1BundleAuto
        const _pm = b.querySelector('[data-u1-pdp-card-promo]')
        const _pf = _pm && _pm.querySelector('[data-u1-pdp-card-promo-off]')
        if (_pm && _pf && b.dataset.u1BundlePromoOrig !== undefined) {
          _pf.textContent = b.dataset.u1BundlePromoOrig
          _pm.setAttribute('hidden', '')
          _pm.setAttribute('aria-hidden', 'true')
          delete b.dataset.u1BundlePromoOrig
        } else if (_pm && _pf && _bundleAccSet.size) {
          // Hide promo on bundle accessories even if JS never touched them (Liquid default)
          const _bh = (b.dataset.u1PdpAccessoryHandle || '').toLowerCase()
          const _inBundle = _bundleAccSet.has(_bh) || Array.from(_bundleAccSet).some((rh) => handleMatch(_bh, rh))
          if (_inBundle && !_pm.hasAttribute('hidden')) {
            if (b.dataset.u1BundlePromoOrig === undefined) b.dataset.u1BundlePromoOrig = _pf.textContent
            _pm.setAttribute('hidden', '')
            _pm.setAttribute('aria-hidden', 'true')
          }
        }
        const _pr = b.querySelector('[data-u1-pdp-card-price-row]')
        if (_pr && b.dataset.u1BundlePriceDisplay !== undefined) {
          _pr.style.display = b.dataset.u1BundlePriceDisplay
          delete b.dataset.u1BundlePriceDisplay
        }
      })
      return
    }

    let remoteInState = false
    let remoteBtn = null

    // Incluye 1 ítem pick-one (p. ej. solo Remote): sin esto no corre el primer click auto.
    if (ar.pickOne && activeHandles.length >= 1) {
      const groupBtns = activeHandles
        .map((rh) => allAcc.find((acc) => handleMatch(acc.dataset.u1PdpAccessoryHandle || '', rh)))
        .filter(Boolean)
      const accLooksSelected = (bb) =>
        !!(
          bb &&
          (bb.classList.contains('is-selected') || bb.getAttribute('aria-pressed') === 'true')
        )
      const selectedMany = groupBtns.filter((bb) => accLooksSelected(bb))
      if (selectedMany.length > 1) {
        const lastH = (() => {
          try {
            return String(window.__u1PickOneLastAccHandle || '').trim().toLowerCase()
          } catch (_) {
            return ''
          }
        })()
        let keepBtn =
          lastH &&
          selectedMany.find((bb) => handleMatch(bb.dataset.u1PdpAccessoryHandle || '', lastH))
        if (!keepBtn) {
          for (const rh of activeHandles) {
            const bb = allAcc.find((acc) => handleMatch(acc.dataset.u1PdpAccessoryHandle || '', rh))
            if (bb && accLooksSelected(bb)) {
              keepBtn = bb
              break
            }
          }
        }
        selectedMany.forEach((bb) => {
          if (bb !== keepBtn && accLooksSelected(bb)) clickAccessoryWithClosedBundleBypass(bb)
        })
      }

      let selectedNow = groupBtns.filter((bb) => accLooksSelected(bb))
      if (!selectedNow.length && activeBtn) {
        let pickBtn = null
        const lastH = (() => {
          try {
            return String(window.__u1PickOneLastAccHandle || '').trim().toLowerCase()
          } catch (_) {
            return ''
          }
        })()
        if (lastH) {
          pickBtn =
            groupBtns.find((bb) => handleMatch(bb.dataset.u1PdpAccessoryHandle || '', lastH)) ||
            null
        }
        if (!pickBtn) {
          pickBtn =
            groupBtns.find((bb) => bb.getAttribute('aria-disabled') !== 'true') || groupBtns[0] || null
        }
        if (pickBtn) {
          try {
            window.__u1PickOneLastAccHandle = String(
              pickBtn.dataset.u1PdpAccessoryHandle || ''
            )
              .trim()
              .toLowerCase()
          } catch (_) {}
          clickAccessoryWithClosedBundleBypass(pickBtn)
        }
      }
    }

    const accLooksSelected = (bb) =>
      !!(
        bb &&
        (bb.classList.contains('is-selected') || bb.getAttribute('aria-pressed') === 'true')
      )
    const pickOneGroupSelected = () => {
      if (!ar || !ar.pickOne) return false
      return activeHandles.some((rh) => {
        const bb = allAcc.find((acc) => handleMatch(acc.dataset.u1PdpAccessoryHandle || '', rh))
        return accLooksSelected(bb)
      })
    }

    activeHandles.forEach((rh) => {
      const b = allAcc.find((acc) => handleMatch(acc.dataset.u1PdpAccessoryHandle || '', rh))
      if (!b) return

      if (ar.pickOne) {
        const selInGroup = pickOneGroupSelected()
        if (!accLooksSelected(b)) {
          if (!selInGroup) {
            if (
              b.dataset.u1BundlePromoOrig !== undefined ||
              b.dataset.u1BundlePriceDisplay !== undefined ||
              b.dataset.u1BundleLocked === 'true'
            ) {
              delete b.dataset.u1BundleLocked
              delete b.dataset.u1BundleAuto
              const pm0 = b.querySelector('[data-u1-pdp-card-promo]')
              const pf0 = pm0 && pm0.querySelector('[data-u1-pdp-card-promo-off]')
              if (pm0 && pf0 && b.dataset.u1BundlePromoOrig !== undefined) {
                pf0.textContent = b.dataset.u1BundlePromoOrig
                pm0.setAttribute('hidden', '')
                pm0.setAttribute('aria-hidden', 'true')
                delete b.dataset.u1BundlePromoOrig
              }
              const pr0 = b.querySelector('[data-u1-pdp-card-price-row]')
              if (pr0 && b.dataset.u1BundlePriceDisplay !== undefined) {
                pr0.style.display = b.dataset.u1BundlePriceDisplay
                delete b.dataset.u1BundlePriceDisplay
              }
            }
            return
          }
          try {
            delete b.dataset.u1BundleLocked
            delete b.dataset.u1BundleAuto
          } catch (_) {}
        } else {
          remoteBtn = b
          remoteInState = true
          try {
            delete b.dataset.u1BundleLocked
            delete b.dataset.u1BundleAuto
          } catch (_) {}
        }
      } else {
        remoteBtn = remoteBtn || b
        const alreadyInState = b.dataset.u1BundleAuto === 'true'
        if (alreadyInState) {
          remoteInState = true
        } else {
          const isOn =
            b.classList.contains('is-selected') ||
            b.getAttribute('aria-pressed') === 'true'
          try {
            delete b.dataset.u1BundleLocked
          } catch (_) {}
          if (!isOn) {
            clickAccessoryWithClosedBundleBypass(b)
            b.dataset.u1BundleLocked = 'true'
            if (
              b.classList.contains('is-selected') ||
              b.getAttribute('aria-pressed') === 'true'
            ) {
              b.dataset.u1BundleAuto = 'true'
              remoteInState = true
            }
          } else {
            b.dataset.u1BundleLocked = 'true'
            b.dataset.u1BundleAuto = 'true'
            remoteInState = true
          }
        }
      }

      const _promoEl = b.querySelector('[data-u1-pdp-card-promo]')
      const _promoOff = _promoEl && _promoEl.querySelector('[data-u1-pdp-card-promo-off]')
      const _promoNote = _promoEl && _promoEl.querySelector('[data-u1-pdp-card-promo-note]')
      const _priceRow = b.querySelector('[data-u1-pdp-card-price-row]')
      if (_promoEl && _promoOff) {
        if (b.dataset.u1BundlePromoOrig === undefined) b.dataset.u1BundlePromoOrig = _promoOff.textContent
        const _lblRaw = String(ar.discountLabel || '').trim()
        let _bundlePromoTxt = _lblRaw || 'Included in Bundle'
        if (labelImpliesFreeAccessory(_lblRaw) && extractPct(_lblRaw) <= 0) {
          _bundlePromoTxt = 'Free'
        }
        _promoOff.textContent = _bundlePromoTxt
        if (ar.pickOne && _promoNote) _promoNote.textContent = ''
        _promoEl.removeAttribute('hidden')
        _promoEl.setAttribute('aria-hidden', 'false')
      }
      if (_priceRow && b.dataset.u1BundlePriceDisplay === undefined) {
        b.dataset.u1BundlePriceDisplay = _priceRow.style.display || ''
        _priceRow.style.display = 'none'
      }
    })

    // Show "Bundle & Save" banner when bundle rule is active
    const _bannerEl = root.querySelector('[data-u1-pdp-bundle-save]')
    if (_bannerEl) { _bannerEl.removeAttribute('hidden'); _bannerEl.setAttribute('aria-hidden', 'false') }

    // Title override
    if (ar.bundleCardTitle) {
      const e = activeBtn.querySelector('[data-u1-pdp-card-title]')
      if (e && activeBtn.dataset.u1BundleOT === undefined) {
        activeBtn.dataset.u1BundleOT = e.textContent
        e.textContent = ar.bundleCardTitle
      }
    }

    // Promo en modelo activo: línea configurada en block Model se conserva cuando pick-one
    if (ar.discountLabel && !ar.pickOne) showModelCardPromo(activeBtn, ar.discountLabel)
    else if (!(ar && ar.pickOne && modelOfferStaticOff(activeBtn))) hideModelCardPromo(activeBtn)

    // ── Auto-calculate bundle prices ──────────────────────────────────────────
    const pct = extractPct(ar.discountLabel || '')
    const remotePriceCents = parseMoneyCents(remoteBtn ? (remoteBtn.dataset.u1PdpInfoPrice || '') : '')
    const freeAccessory = pct <= 0 && labelImpliesFreeAccessory(ar.discountLabel || '')

    // Extra accessories = selected accessories NOT part of this bundle
    const extraAccCents = allAcc
      .filter((b) => {
        if (!b.classList.contains('is-selected')) return false
        return !activeHandles.some((rh) => handleMatch(b.dataset.u1PdpAccessoryHandle || '', rh))
      })
      .reduce((sum, b) => sum + parseMoneyCents(b.dataset.u1PdpInfoPrice || ''), 0)

    // Main price = atcTotal minus gift line (if aplicable) minus other extras
    // When the accessory already carries a 100% discount (set by inline JS syncBundleDiscountUi),
    // its price is already $0 inside curTotal — don't subtract it again.
    const curTotal = Number(root._u1AtcTotalCents || 0) || 0
    const remoteAlreadyDiscounted = remoteBtn && String(remoteBtn.dataset.u1PdpDiscountPercent || '') === '100'
    const remoteContribution = (remoteInState && !remoteAlreadyDiscounted) ? remotePriceCents : 0
    const mainPriceCents = curTotal - remoteContribution - extraAccCents

    let msrpCents = mainPriceCents > 0 && remoteInState && remotePriceCents > 0 ? mainPriceCents + remotePriceCents : 0
    let finalCents = 0
    if (freeAccessory && remoteInState && mainPriceCents > 0 && remotePriceCents > 0) {
      msrpCents = mainPriceCents + remotePriceCents
      finalCents = mainPriceCents
    } else if (msrpCents > 0 && pct > 0) {
      finalCents = Math.round(msrpCents * (100 - pct) / 100)
      if (finalCents % 100 === 50) finalCents += 50
    }

    // Store computed prices on root
    root._u1BundleFinalCents = finalCents
    root._u1BundleMsrpCents = msrpCents
    root._u1BundleExtraAccCents = extraAccCents

    // ── Card price display (tachado MSRP + final) — no en pick-one ni cuando el descuento es accesorio gratis ──
    if (!ar.pickOne && !freeAccessory && msrpCents && finalCents) {
      const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
      const sample  = (totalEl && totalEl.textContent) || ''
      const cardMsrpStr  = sample ? formatCentsLike(msrpCents,  sample) : ''
      const cardFinalStr = sample ? formatCentsLike(finalCents, sample) : ''
      if (cardMsrpStr && cardFinalStr) {
        const r = activeBtn.querySelector('[data-u1-pdp-card-price-row]')
        if (r) {
          const next = `<span class="u1-pdp-card__price u1-pdp-card__price--discount" data-u1-pdp-card-price><span class="u1-pdp-card__price-msrp">${cardMsrpStr}</span><span class="u1-pdp-card__price-final">${cardFinalStr}</span></span>`
          if (activeBtn.dataset.u1BundleOP === undefined) activeBtn.dataset.u1BundleOP = r.innerHTML
          // Cache price strings for display when not active
          activeBtn.dataset.u1BundleCachedMsrp  = cardMsrpStr
          activeBtn.dataset.u1BundleCachedFinal = cardFinalStr
          if (r.innerHTML !== next) r.innerHTML = next
        }
      }
    } else if ((ar.pickOne || freeAccessory) && activeBtn.dataset.u1BundleOP !== undefined) {
      // Restore original card price when pick-one or free-accessory (no strikethrough on model card)
      const r = activeBtn.querySelector('[data-u1-pdp-card-price-row]')
      if (r) r.innerHTML = activeBtn.dataset.u1BundleOP
      delete activeBtn.dataset.u1BundleOP
      delete activeBtn.dataset.u1BundleCachedMsrp
      delete activeBtn.dataset.u1BundleCachedFinal
    }

    // Override CTA total
    if (finalCents) applyBundleTotal(root)
  }

  // ── Event wiring ──────────────────────────────────────────────────────────────

  // Block deselection of locked accessories (capture phase — fires before section handler)
  document.addEventListener(
    'click',
    (e) => {
      const ax = e.target && e.target.closest ? e.target.closest('[data-u1-pdp-accessory]') : null
      if (ax && ax.closest && ax.closest('[id^="U1PdpCustomizer-"]')) {
        try {
          window.__u1PickOneLastAccHandle = String(ax.dataset.u1PdpAccessoryHandle || '')
            .trim()
            .toLowerCase()
        } catch (_) {}
      }
      const btn = ax
      if (btn && btn.dataset.u1BundlePickOneGroup && btn.closest) {
        const rootBar = btn.closest('[id^="U1PdpCustomizer-"]')
        const grpId = btn.dataset.u1BundlePickOneGroup
        if (rootBar && grpId) {
          const grpBtns = Array.from(rootBar.querySelectorAll('[data-u1-pdp-accessory]')).filter(
            (bb) =>
              bb &&
              bb.dataset &&
              String(bb.dataset.u1BundlePickOneGroup || '') === String(grpId)
          )
          const cntSel = grpBtns.filter(
            (bb) =>
              bb.classList.contains('is-selected') || bb.getAttribute('aria-pressed') === 'true'
          ).length
          const thisOn =
            btn.classList.contains('is-selected') || btn.getAttribute('aria-pressed') === 'true'
          if (cntSel === 1 && thisOn) {
            e.stopImmediatePropagation()
            e.preventDefault()
            return
          }
        }
      }
      if (btn && btn.dataset.u1BundleLocked === 'true' && btn.classList.contains('is-selected')) {
        e.stopImmediatePropagation()
        e.preventDefault()
      }
    },
    true
  )

  // Re-sync after any click inside a PDP root
  document.addEventListener('click', (e) => {
    const root = e.target && e.target.closest ? e.target.closest('[id^="U1PdpCustomizer-"]') : null
    if (!root) return
    requestAnimationFrame(() => { try { syncForRoot(root) } catch (_) {} })
  }, false)

  // Watch color/size changes (keyboard nav / programmatic)
  const observeRoot = (root) => {
    const obs = new MutationObserver(() => { try { syncForRoot(root) } catch (_) {} })
    const colorStep = root.querySelector('[data-u1-pdp-step="color"]')
    const sizeStep  = root.querySelector('[data-u1-pdp-step="size"]')
    const accStep   = root.querySelector('[data-u1-pdp-step="accessories"]')
    const attrFilt  = ['class', 'aria-pressed', 'aria-disabled']
    if (colorStep) obs.observe(colorStep, { subtree: true, attributes: true, attributeFilter: attrFilt })
    if (sizeStep)  obs.observe(sizeStep,  { subtree: true, attributes: true, attributeFilter: attrFilt })
    if (accStep)   obs.observe(accStep,   { subtree: true, attributes: true, attributeFilter: attrFilt })
  }

  // Watch CTA total changes and re-apply bundle override
  const observeBundleTotal = (root) => {
    const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
    if (!totalEl) return
    let _busy = false
    const obs = new MutationObserver(() => {
      if (_busy || !root._u1BundleFinalCents) return
      _busy = true
      requestAnimationFrame(() => {
        try { syncForRoot(root) } catch (_) {}
        _busy = false
      })
    })
    obs.observe(totalEl, { characterData: true, childList: true, subtree: true })
  }

  try {
    window.addEventListener(
      'u1:pdp:selection',
      () => {
        requestAnimationFrame(() => {
          document.querySelectorAll('[id^="U1PdpCustomizer-"]').forEach((root) => {
            try { syncForRoot(root) } catch (_) {}
          })
        })
      },
      false
    )
  } catch (_) {}

  const initSync = () => {
    const roots = document.querySelectorAll('[id^="U1PdpCustomizer-"]')
    roots.forEach(root => {
      try { syncForRoot(root) } catch (_) {}
      try { observeRoot(root) } catch (_) {}
      try { observeBundleTotal(root) } catch (_) {}
    })
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSync, { once: true })
  else initSync()
})()

// ─────────────────────────────────────────────────────────────────────────────
// Tiered Promo UI: base flat discount + tiered % off based on accessories.
// Reads from [data-u1-pdp-tiered-discounts] (pdp-customizer-bundle section).
// Independent from closed bundle and open discount mechanics.
// ─────────────────────────────────────────────────────────────────────────────
;(() => {
  // ── Helpers ──────────────────────────────────────────────────────────────

  const handleMatch = (a, b) => {
    const ha = String(a || '').trim().toLowerCase()
    const hb = String(b || '').trim().toLowerCase()
    return !!ha && !!hb && (ha === hb || ha.includes(hb) || hb.includes(ha))
  }

  const parseMoneyCents = (s) => {
    let raw = String(s || '')
    const hasComma = raw.includes(',')
    const hasDot   = raw.includes('.')
    if (hasComma && !hasDot) {
      raw = raw.replace(',', '.')
    } else if (hasComma && hasDot) {
      const lastComma = raw.lastIndexOf(',')
      const lastDot   = raw.lastIndexOf('.')
      if (lastComma > lastDot) {
        raw = raw.replace(/\./g, '').replace(',', '.')
      } else {
        raw = raw.replace(/,/g, '')
      }
    }
    const n = parseFloat(raw.replace(/[^0-9.]/g, '')) || 0
    return Math.round(n * 100)
  }

  const moneyFormat = (sample) => {
    const m = String(sample || '').match(/^([^\d]*)[\d,.]+([^\d]*)$/)
    return m ? { pre: m[1], suf: m[2] } : { pre: '', suf: '' }
  }

  const _sampleUsesCommaDecimal = (sample) => {
    const s = String(sample || '')
    const lastComma = s.lastIndexOf(',')
    const lastDot   = s.lastIndexOf('.')
    if (lastComma < 0) return false
    if (lastDot < 0) return true
    return lastComma > lastDot
  }

  const formatCentsLike = (cents, sample) => {
    const { pre, suf } = moneyFormat(sample)
    if (!pre && !suf && !sample) return ''
    const amount = cents / 100
    const str = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2)
    const formatted = _sampleUsesCommaDecimal(sample) ? str.replace('.', ',') : str
    return pre + formatted + suf
  }

  const roundHalfUp = (cents) => (cents % 100 === 50 ? cents + 50 : cents)

  const splitHandles = (csv) =>
    String(csv || '').split(',').map(s => s.trim().toLowerCase())
      .filter(s => s && s !== '-' && s !== 'none')

  // ── Rules ─────────────────────────────────────────────────────────────────

  const getTieredRules = () => {
    try {
      const el = document.querySelector('[data-u1-pdp-tiered-discounts]')
      return el ? JSON.parse(el.textContent || '[]') : []
    } catch (_) { return [] }
  }

  const rulesForModel = (activeBtn) => {
    if (!activeBtn) return []
    const rules = getTieredRules()
    const mHandle = String(activeBtn.dataset.u1PdpProductModelHandle || '').trim().toLowerCase()
    const mId     = Number(activeBtn.dataset.u1PdpProductModelId || 0) || 0
    return rules.filter(r => {
      if (!r) return false
      const rh = String(r.mainProductHandle || '').trim().toLowerCase()
      const ri = Number(r.mainProductId || 0) || 0
      if (rh && mHandle) return rh === mHandle
      if (ri && mId)     return ri === mId
      return false
    })
  }

  // Best tier = ALL required accessories selected; prefers most requirements (highest tier)
  const bestTier = (rules, selectedHandles) => {
    const matched = rules.filter(r => {
      const req = splitHandles(r.accessoryHandlesCsv)
      return req.length === 0 || req.every(rh => selectedHandles.some(sh => handleMatch(sh, rh)))
    })
    if (!matched.length) return null
    matched.sort((a, b) => splitHandles(b.accessoryHandlesCsv).length - splitHandles(a.accessoryHandlesCsv).length)
    return matched[0]
  }

  // ── CTA total override ────────────────────────────────────────────────────

  const applyTieredTotal = (root, finalCents, msrpCents) => {
    const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
    const msrpEl  = root.querySelector('[data-u1-pdp-atc-total-msrp]')
    const wrapEl  = root.querySelector('[data-u1-pdp-atc-total-wrap]')
    const saveEl  = root.querySelector('[data-u1-pdp-atc-save]')
    if (!totalEl) return

    const sample     = totalEl.textContent || ''
    const finalText  = sample ? formatCentsLike(finalCents, sample) : ''
    const msrpText   = (msrpCents && sample) ? formatCentsLike(msrpCents, sample) : ''
    const saveCents  = msrpCents - finalCents

    if (finalText  && totalEl.textContent !== finalText) totalEl.textContent = finalText
    if (msrpEl && msrpText && msrpEl.textContent !== msrpText) {
      msrpEl.textContent = msrpText
      msrpEl.setAttribute('aria-hidden', 'false')
    }
    if (wrapEl && !wrapEl.classList.contains('is-discount-on')) {
      wrapEl.classList.add('is-discount-on')
      wrapEl.dataset.u1TieredActive = 'true'
    }
    if (saveEl && saveCents > 0 && sample) {
      const saveText = 'Save ' + formatCentsLike(saveCents, sample)
      if (saveEl.textContent !== saveText) saveEl.textContent = saveText
      saveEl.removeAttribute('hidden')
      saveEl.setAttribute('aria-hidden', 'false')
      saveEl.dataset.u1TieredActive = 'true'
    }
  }

  const clearTieredTotal = (root) => {
    const saveEl = root.querySelector('[data-u1-pdp-atc-save]')
    const wrapEl = root.querySelector('[data-u1-pdp-atc-total-wrap]')
    if (saveEl && saveEl.dataset.u1TieredActive) {
      saveEl.setAttribute('hidden', '')
      saveEl.setAttribute('aria-hidden', 'true')
      delete saveEl.dataset.u1TieredActive
    }
    if (wrapEl && wrapEl.dataset.u1TieredActive) {
      wrapEl.classList.remove('is-discount-on')
      delete wrapEl.dataset.u1TieredActive
    }
    root._u1TieredFinalCents = 0
  }

  // ── Main sync ─────────────────────────────────────────────────────────────

  const syncTieredForRoot = (root) => {
    if (!root) return

    const allModelBtns = Array.from(
      root.querySelectorAll(
        '[data-u1-pdp-product-model], [data-u1-pdp-model]'
      )
    )
    const activeBtn    = allModelBtns.find(b => b.classList.contains('is-selected')) || null
    const allAcc       = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'))
    const allRules     = getTieredRules()

    // ── Revert/keep card prices for non-active model buttons ──────────────
    allModelBtns.forEach(b => {
      if (b === activeBtn) return
      const bHandle  = String(b.dataset.u1PdpProductModelHandle || '').toLowerCase()
      const hasRule  = allRules.some(r => String(r.mainProductHandle || '').toLowerCase() === bHandle)
      const priceRow = b.querySelector('[data-u1-pdp-card-price-row]')

      if (hasRule && b.dataset.u1TieredCachedMsrp && priceRow) {
        // Keep showing cached discounted price
        const cM = b.dataset.u1TieredCachedMsrp, cF = b.dataset.u1TieredCachedFinal
        const next = `<span class="u1-pdp-card__price u1-pdp-card__price--discount" data-u1-pdp-card-price><span class="u1-pdp-card__price-msrp">${cM}</span><span class="u1-pdp-card__price-final">${cF}</span></span>`
        if (priceRow.innerHTML !== next) priceRow.innerHTML = next
        delete b.dataset.u1TieredOP
      } else if (b.dataset.u1TieredOP !== undefined) {
        if (priceRow) priceRow.innerHTML = b.dataset.u1TieredOP
        delete b.dataset.u1TieredOP
        delete b.dataset.u1TieredCachedMsrp
        delete b.dataset.u1TieredCachedFinal
      }
    })

    const tieredRulesForActive = rulesForModel(activeBtn)

    if (!tieredRulesForActive.length || !activeBtn) {
      clearTieredTotal(root)
      return
    }

    // If closed bundle is active for this model, don't interfere
    if (Number(root._u1BundleFinalCents || 0) > 0) return

    // Selected accessory handles
    const selectedHandles = allAcc
      .filter(b => b.classList.contains('is-selected'))
      .map(b => String(b.dataset.u1PdpAccessoryHandle || '').toLowerCase())
      .filter(Boolean)

    const tier = bestTier(tieredRulesForActive, selectedHandles)
    if (!tier) { clearTieredTotal(root); return }

    const baseDCents  = Math.round(parseFloat(String(tier.baseDiscountAmount || '0').replace(/[^0-9.]/g, '')) * 100)
    const tierPct     = Number(tier.discountPct || 0)
    const sectionTotal = Number(root._u1AtcTotalCents || 0) || 0
    if (!sectionTotal) return

    // CTA prices
    const discountedTotal = sectionTotal - baseDCents
    let finalCents = tierPct > 0
      ? Math.round(discountedTotal * (100 - tierPct) / 100)
      : discountedTotal
    finalCents = roundHalfUp(finalCents)
    const msrpCents = sectionTotal

    root._u1TieredFinalCents = finalCents
    applyTieredTotal(root, finalCents, msrpCents)

    // ── Model card price (base discount only, no accessory %) ──────────────
    const selectedAccCents = allAcc
      .filter(b => b.classList.contains('is-selected'))
      .reduce((sum, b) => sum + parseMoneyCents(b.dataset.u1PdpInfoPrice || ''), 0)
    const modelPriceCents = sectionTotal - selectedAccCents

    if (modelPriceCents > 0 && baseDCents > 0) {
      const totalEl      = root.querySelector('[data-u1-pdp-atc-total]')
      const sample       = (totalEl && totalEl.textContent) || ''
      const cardMsrpStr  = sample ? formatCentsLike(modelPriceCents, sample) : ''
      let   cardFinalCents = modelPriceCents - baseDCents
      cardFinalCents = roundHalfUp(cardFinalCents)
      const cardFinalStr = sample ? formatCentsLike(cardFinalCents, sample) : ''

      if (cardMsrpStr && cardFinalStr) {
        const priceRow = activeBtn.querySelector('[data-u1-pdp-card-price-row]')
        if (priceRow) {
          const next = `<span class="u1-pdp-card__price u1-pdp-card__price--discount" data-u1-pdp-card-price><span class="u1-pdp-card__price-msrp">${cardMsrpStr}</span><span class="u1-pdp-card__price-final">${cardFinalStr}</span></span>`
          if (activeBtn.dataset.u1TieredOP === undefined) activeBtn.dataset.u1TieredOP = priceRow.innerHTML
          activeBtn.dataset.u1TieredCachedMsrp  = cardMsrpStr
          activeBtn.dataset.u1TieredCachedFinal = cardFinalStr
          if (priceRow.innerHTML !== next) priceRow.innerHTML = next
        }
      }
    }
  }

  // ── Event wiring ──────────────────────────────────────────────────────────

  document.addEventListener('click', (e) => {
    const root = e.target && e.target.closest ? e.target.closest('[id^="U1PdpCustomizer-"]') : null
    if (!root) return
    requestAnimationFrame(() => { try { syncTieredForRoot(root) } catch (_) {} })
  }, false)

  const observeTieredRoot = (root) => {
    const obs = new MutationObserver(() => { try { syncTieredForRoot(root) } catch (_) {} })
    const colorStep = root.querySelector('[data-u1-pdp-step="color"]')
    const sizeStep  = root.querySelector('[data-u1-pdp-step="size"]')
    if (colorStep) obs.observe(colorStep, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-pressed'] })
    if (sizeStep)  obs.observe(sizeStep,  { subtree: true, attributes: true, attributeFilter: ['class', 'aria-pressed'] })
  }

  const observeTieredTotal = (root) => {
    const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
    if (!totalEl) return
    let _busy = false
    const obs = new MutationObserver(() => {
      if (_busy || !root._u1TieredFinalCents) return
      _busy = true
      requestAnimationFrame(() => {
        try { syncTieredForRoot(root) } catch (_) {}
        _busy = false
      })
    })
    obs.observe(totalEl, { characterData: true, childList: true, subtree: true })
  }

  const initTiered = () => {
    if (!getTieredRules().length) return
    document.querySelectorAll('[id^="U1PdpCustomizer-"]').forEach(root => {
      try { syncTieredForRoot(root) } catch (_) {}
      try { observeTieredRoot(root) } catch (_) {}
      try { observeTieredTotal(root) } catch (_) {}
    })
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTiered, { once: true })
  else initTiered()
})()

// ─────────────────────────────────────────────────────────────────────────────
// Compare-at-price CTA indicator
// If the active model product has compare_at_price > price in Shopify admin,
// the snippet sets data-u1-pdp-info-save-cents on the button.
// This IIFE reads that value and shows MSRP + Save $XX in the CTA automatically.
// ─────────────────────────────────────────────────────────────────────────────
;(() => {
  const moneyFormat = (sample) => {
    const m = String(sample || '').match(/^([^\d]*)[\d,.]+([^\d]*)$/)
    return m ? { pre: m[1], suf: m[2] } : { pre: '', suf: '' }
  }

  const formatCentsLike = (cents, sample) => {
    const { pre, suf } = moneyFormat(sample)
    if (!pre && !suf && !sample) return ''
    const amount = cents / 100
    const str = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2)
    return pre + str + suf
  }

  const syncComparePriceForRoot = (root) => {
    if (!root) return

    // Yield to other promo IIFEs if they're already overriding the CTA
    if (Number(root._u1BundleFinalCents || 0) > 0) return
    if (Number(root._u1TieredFinalCents || 0) > 0) return

    const allModelBtns = Array.from(
      root.querySelectorAll(
        '[data-u1-pdp-product-model], [data-u1-pdp-model]'
      )
    )
    const activeBtn    = allModelBtns.find(b => b.classList.contains('is-selected')) || null

    const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
    const msrpEl  = root.querySelector('[data-u1-pdp-atc-total-msrp]')
    const wrapEl  = root.querySelector('[data-u1-pdp-atc-total-wrap]')
    const saveEl  = root.querySelector('[data-u1-pdp-atc-save]')

    const saveCents = activeBtn
      ? (parseInt(activeBtn.dataset.u1PdpInfoSaveCents || '0', 10) || 0)
      : 0

    if (!saveCents || !totalEl) {
      if (saveEl && saveEl.dataset.u1CompareActive) {
        saveEl.setAttribute('hidden', '')
        saveEl.setAttribute('aria-hidden', 'true')
        delete saveEl.dataset.u1CompareActive
      }
      if (wrapEl && wrapEl.dataset.u1CompareActive) {
        wrapEl.classList.remove('is-discount-on')
        delete wrapEl.dataset.u1CompareActive
      }
      if (msrpEl && msrpEl.dataset.u1CompareActive) {
        msrpEl.textContent = ''
        msrpEl.setAttribute('aria-hidden', 'true')
        delete msrpEl.dataset.u1CompareActive
      }
      return
    }

    const sectionTotal = Number(root._u1AtcTotalCents || 0) || 0
    if (!sectionTotal) return

    const sample    = totalEl.textContent || ''
    if (!sample) return

    const msrpTotal = sectionTotal + saveCents
    const msrpText  = formatCentsLike(msrpTotal, sample)
    const saveText  = 'Save ' + formatCentsLike(saveCents, sample)

    if (msrpEl && msrpText && msrpEl.textContent !== msrpText) {
      msrpEl.textContent = msrpText
      msrpEl.setAttribute('aria-hidden', 'false')
      msrpEl.dataset.u1CompareActive = 'true'
    }
    if (wrapEl && !wrapEl.classList.contains('is-discount-on')) {
      wrapEl.classList.add('is-discount-on')
      wrapEl.dataset.u1CompareActive = 'true'
    }
    if (saveEl && saveText && saveEl.textContent !== saveText) {
      saveEl.textContent = saveText
      saveEl.removeAttribute('hidden')
      saveEl.setAttribute('aria-hidden', 'false')
      saveEl.dataset.u1CompareActive = 'true'
    }
  }

  document.addEventListener('click', (e) => {
    const root = e.target && e.target.closest ? e.target.closest('[id^="U1PdpCustomizer-"]') : null
    if (!root) return
    requestAnimationFrame(() => { try { syncComparePriceForRoot(root) } catch (_) {} })
  }, false)

  const observeCompareTotal = (root) => {
    const totalEl = root.querySelector('[data-u1-pdp-atc-total]')
    if (!totalEl) return
    const obs = new MutationObserver(() => {
      try { syncComparePriceForRoot(root) } catch (_) {}
    })
    obs.observe(totalEl, { characterData: true, childList: true, subtree: true })
  }

  const initComparePrice = () => {
    document.querySelectorAll('[id^="U1PdpCustomizer-"]').forEach(root => {
      try { syncComparePriceForRoot(root) } catch (_) {}
      try { observeCompareTotal(root) } catch (_) {}
    })
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initComparePrice, { once: true })
  else initComparePrice()
})()
